<div *ngIf="canAccess">
  <h2 class="!mt-0">
    Editar tarifa internacional
  </h2>

  <form [formGroup]="createForm">

    <!-- Estructura dinámica basada en isMobile -->
    <div class="flex-col gap-4">
      <!-- Campos para pantallas más grandes (dos columnas) -->

      <div class="grid grid-cols-2 gap-4">
        <!-- Network -->
        <mat-form-field class="w-full">
          <mat-label>
            Network
          </mat-label>
          <input formControlName="network"
                 type="text"
                 matInput
                 placeholder="Network" />
        </mat-form-field>

        <!-- Country code -->
        <mat-form-field class="w-full">
          <mat-label>
            Country code
          </mat-label>
          <input formControlName="countryCode"
                 type="text"
                 matInput
                 placeholder="Country code" />
        </mat-form-field>

        <!-- Vendor -->
        <mat-form-field class="w-full">
          <mat-label>
            Vendor
          </mat-label>
          <input formControlName="vendor"
                 type="text"
                 matInput
                 placeholder="vendor" />
        </mat-form-field>

        <!-- Amount -->
        <mat-form-field class="w-full">
          <mat-label>
            Amount
          </mat-label>
          <input formControlName="amount"
                 type="text"
                 matInput
                 placeholder="Amount" />
        </mat-form-field>

        <!-- Default -->
        <mat-form-field class="w-full">
          <mat-label>
            Default
          </mat-label>
          <input formControlName="default"
                 type="text"
                 matInput
                 placeholder="Default" />
        </mat-form-field>

        <!-- Regex filter -->
        <mat-form-field class="w-full">
          <mat-label>
            Regex filter
          </mat-label>
          <input formControlName="regexFilter"
                 type="text"
                 matInput
                 placeholder="Regex filter" />
        </mat-form-field>

        <!-- Created at -->
        <mat-form-field class="w-full">
          <mat-label>
            Created at
          </mat-label>
          <input formControlName="createdAt"
                 type="text"
                 matInput
                 placeholder="Created at" />
        </mat-form-field>

        <!-- Updated at -->
        <mat-form-field class="w-full">
          <mat-label>
            Updated at
          </mat-label>
          <input formControlName="updatedAt"
                 type="text"
                 matInput
                 placeholder="Updated at" />
        </mat-form-field>

      </div>

    </div>

     <!-- Botones -->
    <div class="flex justify-between gap-4 mt-12">
      <app-button expand="full" color="secondary" (click)="goBack()">
        {{ 'COMMON.CANCEL' | translate }}
      </app-button>
      <app-button expand="full" (click)="onUpdate()">
        {{ 'COMMON.CONFIRM' | translate }}
      </app-button>
    </div>

  </form>
</div>

<style>
  .grid {
  display: grid;
}

.grid-cols-2 {
  grid-template-columns: repeat(2, 1fr);
}

.gap-4 {
  gap: 16px;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.w-full {
  width: 100%;
}

.m-top {
  margin-top: 24px;
}

.m-bottom {
  margin-bottom: 24px;
}
</style>
